
/* eslint-disable @typescript-eslint/no-explicit-any */
import { DialogRef } from "@angular/cdk/dialog";
export function updateDialogWidth(dialogRef: DialogRef<unknown, any>): number {
  const isMobile = window.innerWidth <= 500;
  const newDialogWidth = isMobile
    ? window.innerWidth * 0.85
    : (window.innerWidth - 88) * 0.7;

  if (dialogRef) {
    dialogRef.updateSize(`${newDialogWidth}px`);
  }

  return newDialogWidth;
}

export function isSameDate(date1: Date, date2: Date, preciseTimeCheck = true): boolean {
  if (!preciseTimeCheck) {
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  }

  return date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate() &&
    date1.getHours() === date2.getHours() &&
    date1.getMinutes() === date2.getMinutes() &&
    date1.getSeconds() === date2.getSeconds() &&
    date1.getMilliseconds() === date2.getMilliseconds();
}
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PHONE_REGEX = /^\+[0-9]{6,20}$/;